import React from 'react';
import { StatusWrapper } from './Styled';
import {PRODUCT_STATUS} from "../../../data/enums";

interface StatusActiveProps {
  isActive: boolean;
  activeText?: string;
  inactiveText?: string;
}

const StatusActive = ({ isActive, activeText = PRODUCT_STATUS.ACTIVE, inactiveText = PRODUCT_STATUS.INACTIVE }: StatusActiveProps) => {
  return (
    <StatusWrapper isActive={isActive}>
      {isActive ? activeText : inactiveText}
    </StatusWrapper>
  );
};

export default StatusActive;